export default {
  exportForceUpdateKey(st) {
    return st.forceUpdateKey;
  },
  // exportIndexBanner(st) {
  //   return st.indexBanner;
  // },
  exportFlowBarFixed(st) {
    return st.screenStatus.flowBarFixed;
  },
  exportRwdType(st) {
    return st.screenStatus.rwdType;
  },
  exportPopBoxStatus(st) {
    return st.popBox;
  },
  exportPopStartupStatus(st) {
    return st.popStartupBox;
  },
  exportPopProgressStatus(st) {
    return st.popProgressBox;
  },
  exportPopBloodUploadStatus(st) {
    return st.popBloodUploadBox;
  },
  exportPopShowTutorialStatus(st) {
    return st.popShowTutorial;
  },
  exportPopYoutubeStatus(st) {
    return st.popYoutubePlayer;
  },
  exportPopCourseStatus(st) {
    return st.popCoursePlayer;
  },
  exportPopZoomStatus(st) {
    return st.popImgZoom;
  },
  exportPopQRcodeStatus(st) {
    return st.popQrCode;
  },
  exportPopTeamFeatureStatus(st) {
    return st.popTeamFeature;
  },
  exportPopDrugStatus(st) {
    return st.popDrugBox;
  },
  exportPopBusinessRequest(st) {
    return st.popBusinessRequest;
  },
  // exportPopShopStuffStatus(st) {
  //   return st.popShopStuffBox;
  // },
  exportPopAgreeListStatus(st) {
    return st.popAgreeList;
  },
  exportPopChatAdditionalStatus(st) {
    return st.popChatAdditional;
  },
  exportPopQuestionStatus(st) {
    return st.popControlQuestion;
  },
  // exportPopBlessStatus(st) {
  //   return st.popSendBless;
  // },
  // exportPopDeleteResumeStatus(st) {
  //   return st.popDeleteResume;
  // },
  // exportPopDeleteBlessStatus(st) {
  //   return st.popDeleteBless;
  // },
  // exportPopDeleteReplyStatus(st) {
  //   return st.popDeleteReply;
  // },
  // exportPopDeleteAskStatus(st) {
  //   return st.popDeleteAsk;
  // },
  // exportPopRecordAdviseStatus(st) {
  //   return st.popRecordAdvise;
  // },
  exportPopDeleteTranslationStatus(st) {
    return st.popDeleteTranslation;
  },
  exportPopDeleteEproStatus(st) {
    return st.popDeleteEpro;
  },
  exportPopReportStatus(st) {
    return st.popReport;
  },
  exportPopHelpFilterStatus(st) {
    return st.popHelpFilter;
  },
  exportPopFreeTrailStatus(st) {
    return st.popFreeTrail;
  },
  exportPopTranslatorStatus(st) {
    return st.popTranslator;
  },
  exportPopAnalysisStatus(st) {
    return st.popAnalysis;
  },
  exportPopDietRecognizeStatus(st) {
    return st.popDietRecognize;
  },
  exportPopLatestNewsStatus(st) {
    return st.popLatestNews;
  },
  exportPopVendorProfileStatus(st) {
    return st.popVendorProfile;
  },
  exportPopEproRecordDetail(st) {
    return st.popEproRecordDetail;
  },
  exportPopChronicBloodDetail(st) {
    return st.popChronicBloodDetail;
  },
  exportPopCheckListBox(st) {
    return st.popCheckListBox;
  },
};
